module.exports = __webpack_public_path__ + "static/media/feregotti-julian.6d38c9d4.jpg";